import React, { FunctionComponent } from "react";

export const RegisterForm: FunctionComponent = () => <div>Register Form</div>;
